import { render } from "./Thank.vue?vue&type=template&id=b7b3ae2e&scoped=true"
import script from "./Thank.vue?vue&type=script&lang=js"
export * from "./Thank.vue?vue&type=script&lang=js"

import "./Thank.vue?vue&type=style&index=0&id=b7b3ae2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7b3ae2e"]])

export default __exports__